<template>
  <div v-if="showDialog" class="dialog-wrapper">
    <div class="dialog">
      <div class="order-status-img">
        <img src="../../assets/images/orderStatusExpTime.png">
      </div>
      <h2 class="dialog-title">Payment overtime</h2>
      <h2 class="error-msg">Please pay again</h2>
      <button @click="closeDialog" class="dialog-button">Done</button>
      <a @click="closeDialog" class="dialog-content">Back to home</a>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      showDialog: false
    };
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    closeDialog() {
      // this.showDialog = false;
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.order-status-img {

}

.dialog {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  max-width: 600px;
  width: 80%;
}

.dialog-title {
  font-size: 0.35rem;
  margin-bottom: 0.2rem;
  margin-top: 0.0rem;
}

.error-msg {
  font-size: 0.30rem;
  font-weight: 400;
  color: #FF0202;
}

.dialog-content {
  display: block;
  color: #3784F9;
  font-size: 0.24rem;
  margin: 0.13rem 0;
}

.dialog-button {
  background-color: #007bff;
  font-size: 0.26rem;
  font-weight: 200;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 0.5rem;
  cursor: pointer;
}

.dialog-button:hover {
  background-color: #0056b3;
}
</style>



// WEBPACK FOOTER //
// src/pages/ngn/timeout.vue